import * as React from "react";
import {
	createNativeStackNavigator,
	NativeStackScreenProps,
} from "@react-navigation/native-stack";
import AuthStackHeader from "../AuthStack/AuthStackHeader";
import CreateAccount from "./CreateAccount";
import TermsOfService from "./TermsOfService";
import TermsOfServiceHeader from "./TermsOfServiceHeader";

type NewUserStackNavParamList = {
	CreateAccount: undefined;
	TermsOfService: undefined;
	AuthStack: { screen: string };
};

export type CreateAccountScreenProps = NativeStackScreenProps<
	NewUserStackNavParamList,
	"CreateAccount"
>;

const NewUserStackNav = createNativeStackNavigator<NewUserStackNavParamList>();

const NewUserStack = () => {
	return (
		<NewUserStackNav.Navigator
			initialRouteName="CreateAccount"
			screenOptions={{
				header: props => {
					if (props.route.name === "TermsOfService")
						return <TermsOfServiceHeader />;
					return <AuthStackHeader />;
				},
			}}
		>
			<NewUserStackNav.Screen name="CreateAccount" component={CreateAccount} />
			<NewUserStackNav.Screen
				name="TermsOfService"
				component={TermsOfService}
			/>
		</NewUserStackNav.Navigator>
	);
};

export default NewUserStack;
